@if (form) {
  <form
    (submitted)="submitForm($event)"
    [appFormDisabled]="formSubmitted"
    [formGroup]="form"
    appFormSubmit
    class="contact-details-form"
  >
    <app-grid-row>
      <app-grid-column [md]="6">
        <div class="contact-details-form__left-column">
          <div class="contact-details-form__group">
            @if (customerDetails(); as details) {
              <div class="contact-details-form__customer-details-panel">
                <p class="contact-details-form__customer-details-panel-title">
                  {{ "CONTACT_DETAILS_PAGE_SUBTITLE" | translate }}
                </p>
                <p
                  [appQmSanitise]="'block'"
                  class="contact-details-form__customer-name"
                >
                  {{
                    `${details.title}. ${details.firstName} ${details.surname}`
                      | titlecase
                  }}
                </p>
                <p
                  [appQmSanitise]="'block'"
                  class="contact-details-form__customer-address"
                >
                  {{ details.address | appAddressToArray | conjunction: "," }}
                </p>
              </div>
            }

            <app-form-field formControlName="marketingPreferencePost">
              <app-form-checkbox
                [label]="
                  'CONTACT_DETAILS_FORM_POST_MARKETING_PREFERENCE'
                    | translate: { clientName }
                "
              />
            </app-form-field>
          </div>

          <div class="contact-details-form__group">
            <app-form-field
              [appFormField]="formFields.email"
              [hint]="customerHasSelectedToPurchasePlan() ? ('CONTACT_DETAILS_FORM_EMAIL_HINT' | translate) : undefined"
              formControlName="email"
            >
              <app-form-email-input [appQmSanitise]="'block'" />
            </app-form-field>

            <app-form-field
              [class.hidden]="!customerHasSelectedToPurchasePlan()"
              class="contact-details-form__marketing-preference-email"
              formControlName="marketingPreferenceEmail"
            >
              <div class="contact-details-form__marketing-preference-email__inner">
                <app-form-checkbox
                  [label]="
                    'CONTACT_DETAILS_FORM_EMAIL_MARKETING_PREFERENCE'
                      | translate: { clientName }
                  "
                />
              </div>
            </app-form-field>
          </div>

          <div class="contact-details-form__group">
            <app-form-field
              [appFormField]="formFields.phone"
              [hint]="customerHasSelectedToPurchasePlan() ? ('CONTACT_DETAILS_FORM_PHONE_HINT' | translate) : undefined"
              formControlName="phone"
            >
              <app-form-telephone-input [appQmSanitise]="'block'" />
            </app-form-field>

            @if (customerHasSelectedToPurchasePlan()) {
              <div class="contact-details-form__marketing-preference-phone">
                {{
                  "CONTACT_DETAILS_FORM_PHONE_MARKETING_PREFERENCE_PURCHASE"
                    | translate
                }}
                <app-link
                  [navigationLink]="{
                    label: `${clientName} Privacy Policy`,
                    href: privacyPolicyLinkExternal ?? '',
                  }"
                  [newWindow]="true"
                  class="link--regular"
                />
                &
                <app-link
                  [navigationLink]="{
                    label: 'Domestic & General Group Privacy Policy',
                    href:
                      privacyPolicyLink ??
                      `https://${this.domainId}.partners.domesticandgeneral.com/register/support/privacy-policy`,
                  }"
                  [newWindow]="true"
                  class="link--regular"
                />.
              </div>
            } @else {
              <div class="contact-details-form__marketing-preference-phone">
                {{
                  "CONTACT_DETAILS_FORM_PHONE_MARKETING_PREFERENCE_NO_PURCHASE"
                    | translate
                }}
                <app-link
                  [navigationLink]="{
                    label: `${clientName} Privacy Policy`,
                    href: privacyPolicyLinkExternal ?? '',
                  }"
                  [newWindow]="true"
                  class="link--regular"
                />
                &
                <app-link
                  [navigationLink]="{
                    label: 'Domestic & General Group Privacy Policy',
                    href:
                      privacyPolicyLink ??
                      `https://${this.domainId}.partners.domesticandgeneral.com/register/support/privacy-policy`,
                  }"
                  [newWindow]="true"
                  class="link--regular"
                />.
              </div>
            }
          </div>

          @if (
            customerHasSelectedToRegisterOnly() &&
            !showMultiPlanJourney() &&
            hasUpsellQuote()
          ) {
            <app-upsell-checkbox />
          }
        </div>
      </app-grid-column>

      <app-grid-column [block]="'md'" [hidden]="'xs'" [md]="6">
        <app-basket
          [startCollapsed]="false"
          appSticky
          class="contact-details-form__basket"
        />
      </app-grid-column>
    </app-grid-row>

    <div class="contact-details-form__submit-container">
      <app-form-submit-button
        [fill]="true"
        [loading]="formSubmitted"
        class="contact-details-form__submit"
      >
        {{
          customerHasSelectedToPurchasePlan()
            ? ("CONTACT_DETAILS_FORM_CTA_CONTINUE_TO_PAYMENT" | translate)
            : ("CONTACT_DETAILS_FORM_CTA_CONFIRM_REGISTRATION" | translate)
        }}
      </app-form-submit-button>
    </div>
  </form>
}
